<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar v-if="this.receiptData.tranMode !== 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-plus</v-icon>
              <v-toolbar-title>Create New Receipt</v-toolbar-title>
            </v-toolbar>
            <v-toolbar v-if="this.receiptData.tranMode === 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-pencil</v-icon>
              <v-toolbar-title>Edit Receipt </v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabsNav">
              <v-tab @click.native="doValidateMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doValidateMandatory(1)">Optional</v-tab>
              <v-tab @click.native="doValidateMandatory(2)">Payment Method</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabsNav" touchless>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory" eager>
                <form data-vv-scope="receiptsMandatoryForm">
                  <v-flex xs12>
                    <v-expansion-panels v-model="headerPanel" multiple>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div><v-icon>mdi-filter-variant</v-icon> Headers</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card-text>
                            <v-container fluid grid-list-lg>
                              <v-layout row wrap>
                                <v-flex md6 xs12>
                                  <v-autocomplete
                                    :items="branches"
                                    v-model="mulAcctRcptForm.branch"
                                    :label="mulAcctRcptLabel.branch"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="mulAcctRcptForm.branch"
                                    :data-vv-as="mulAcctRcptLabel.branch"
                                    v-validate="'required'"
                                    :error-messages="errors.collect('mulAcctRcptForm.branch')"
                                    @change="doGetDefaultBankNo()"
                                    clearable
                                    :disabled="this.receiptData.tranMode === 'R' || this.defaultForm.isDisabled"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-checkbox
                                    color="primary"
                                    :label="mulAcctRcptLabel.docAE"
                                    v-model="mulAcctRcptForm.docAE"
                                    @change="checkDocAE($event)"
                                    :disabled="this.receiptData.tranMode === 'R' || this.defaultForm.isDisabled"
                                  ></v-checkbox>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="mulAcctRcptForm.documentNo"
                                    :disabled="isDisabledDocNo || this.receiptData.tranMode === 'R'"
                                    :label="mulAcctRcptLabel.documentNo"
                                    @blur="checkDocNo"
                                    v-validate="docNoValidation"
                                    :error-messages="errors.collect('mulAcctRcptForm.documentNo')"
                                    data-vv-name="mulAcctRcptForm.documentNo"
                                    :data-vv-as="mulAcctRcptLabel.documentNo"
                                    :maxlength="8"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md6 xs12>
                                  <cal-picker
                                    v-model="mulAcctRcptForm.transactionDateDisp"
                                    :label="mulAcctRcptLabel.transactionDateDisp"
                                    :data-vv-as="mulAcctRcptLabel.transactionDateDisp"
                                    v-validate="'required'"
                                    :min="this.parseDateISO(this.tDateRange.effDate)"
                                    :max="this.parseDateISO(this.tDateRange.expDate)"
                                    data-vv-name="mulAcctRcptForm.transactionDateDisp"
                                    :error-messages="errors.collect('mulAcctRcptForm.transactionDateDisp')"
                                    @change="checkCurrRate"
                                    :disabled="this.defaultForm.isDisabled"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex md5 xs12>
                                  <v-autocomplete
                                    :items="banks"
                                    v-model="mulAcctRcptForm.depositAcct"
                                    item-text="label"
                                    item-value="value"
                                    :label="mulAcctRcptLabel.depositAcct"
                                    :error-messages="errors.collect('mulAcctRcptForm.depositAcct')"
                                    data-vv-name="mulAcctRcptForm.depositAcct"
                                    :data-vv-as="mulAcctRcptLabel.depositAcct"
                                    v-validate="'required'"
                                    @change="getBankInfo($event)"
                                    clearable
                                    :disabled="this.defaultForm.isDisabled || this.initDisabled"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon
                                        color="info"
                                        @click="showBankNoHelpList = true"
                                        v-text="'mdi-magnify'"
                                        :disabled="this.defaultForm.isDisabled || this.initDisabled"
                                      ></v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-autocomplete>
                                </v-flex>
                                <v-flex md1 xs12>
                                  <v-autocomplete
                                    :items="funds"
                                    v-model="mulAcctRcptForm.fund"
                                    :label="mulAcctRcptLabel.fund"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="mulAcctRcptForm.fund"
                                    :data-vv-as="mulAcctRcptLabel.fund"
                                    :error-messages="errors.collect('mulAcctRcptForm.fund')"
                                    disabled
                                  />
                                </v-flex>
                                <v-flex md6 xs12>
                                  <v-autocomplete
                                    :items="paymentmethods"
                                    v-model="mulAcctRcptForm.paymentMethod"
                                    :label="mulAcctRcptLabel.paymentMethod"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="mulAcctRcptForm.paymentMethod"
                                    :data-vv-as="mulAcctRcptLabel.paymentMethod"
                                    v-validate="'required'"
                                    :error-messages="errors.collect('mulAcctRcptForm.paymentMethod')"
                                    @change="getPaymentMethod($event)"
                                    :disabled="this.defaultForm.isDisabled || this.initDisabled"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-autocomplete
                                    :items="gstIOOptions"
                                    v-model="mulAcctRcptForm.gstIO"
                                    :label="mulAcctRcptLabel.gstIO"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="gstIO"
                                    :data-vv-as="mulAcctRcptLabel.gstIO"
                                    :error-messages="errors.collect('gstIO')"
                                    @change="changeGstIO($event)"
                                    :disabled="this.defaultForm.isDisabled || this.initDisabled"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-autocomplete
                                    :items="gstStatuses"
                                    v-model="mulAcctRcptForm.gstStatus"
                                    :label="mulAcctRcptLabel.gstStatus"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="gstIO"
                                    :data-vv-as="mulAcctRcptLabel.gstStatus"
                                    :error-messages="errors.collect('gstStatus')"
                                    @change="changeGstRate($event)"
                                    disabled
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-text-field
                                    v-model="mulAcctRcptForm.gstRate"
                                    :disabled="true"
                                    :label="mulAcctRcptLabel.gstRate"
                                    :error-messages="errors.collect('gstRate')"
                                    data-vv-name="gstRate"
                                    :data-vv-as="mulAcctRcptLabel.gstRate"
                                    v-validate="'entry|max:60'"
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="accounts"
                                v-model="mulAcctRcptForm.receivedFrom"
                                item-text="label"
                                item-value="value"
                                :label="mulAcctRcptLabel.receivedFrom"
                                :error-messages="errors.collect('mulAcctRcptForm.receivedFrom')"
                                data-vv-name="mulAcctRcptForm.receivedFrom"
                                :data-vv-as="mulAcctRcptLabel.receivedFrom"
                                v-validate="'required'"
                                @change="getAcctInfo($event)"
                                clearable
                                :disabled="this.initDisabled"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon
                                    color="info"
                                    @click="showAcctNoHelpList = true"
                                    v-text="'mdi-magnify'"
                                    :disabled="this.initDisabled"
                                  ></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="acctnosuffixes"
                                v-model="mulAcctRcptForm.accountNoSuffixDesc"
                                item-text="label"
                                item-value="value"
                                :label="mulAcctRcptLabel.accountNoSuffixDesc"
                                :error-messages="errors.collect('mulAcctRcptForm.accountNoSuffixDesc')"
                                data-vv-name="mulAcctRcptForm.accountNoSuffixDesc"
                                :data-vv-as="mulAcctRcptLabel.accountNoSuffixDesc"
                                v-validate="'required|entry|max:60'"
                                @change="getAcctNoSfxInfo($event)"
                                clearable
                                :disabled="this.initDisabled"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon
                                    color="info"
                                    @click="showAcctSufHelpList = true"
                                    v-text="'mdi-magnify'"
                                    :disabled="this.initDisabled"
                                  ></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="amountcurrencies"
                                v-model="mulAcctRcptForm.amountCurr"
                                :label="mulAcctRcptLabel.amountCurr"
                                item-text="label"
                                item-value="value"
                                :error-messages="errors.collect('mulAcctRcptForm.amountCurr')"
                                data-vv-name="mulAcctRcptForm.amountCurr"
                                :data-vv-as="mulAcctRcptLabel.amountCurr"
                                v-validate="'required'"
                                clearable
                                :disabled="this.defaultForm.isDisabled || this.initDisabled"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon
                                    color="info"
                                    @click="showCurrHelpList = true"
                                    v-text="'mdi-magnify'"
                                    :disabled="this.defaultForm.isDisabled || this.initDisabled"
                                  ></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="amount"
                                v-model="mulAcctRcptForm.amount"
                                :label="mulAcctRcptLabel.amount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                :error-messages="errors.collect('mulAcctRcptForm.amount')"
                                data-vv-name="mulAcctRcptForm.amount"
                                :data-vv-as="mulAcctRcptLabel.amount"
                                v-validate="'required|mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.01'"
                                @blur="calculateAmount()"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex md3 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctRcptForm.gstAmountCurr"
                                :label="mulAcctRcptLabel.gstAmountCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctRcptForm.gstAmountCurr"
                                :data-vv-as="mulAcctRcptLabel.gstAmountCurr"
                                :error-messages="errors.collect('mulAcctRcptForm.gstAmountCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                v-model="mulAcctRcptForm.gstAmountAE"
                                :disabled="isGstAmtAE"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="gstAmount"
                                v-model="mulAcctRcptForm.gstAmount"
                                :disabled="isGstAmount"
                                :label="mulAcctRcptLabel.gstAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                :error-messages="errors.collect('mulAcctRcptForm.gstAmount')"
                                data-vv-name="mulAcctRcptForm.gstAmount"
                                :data-vv-as="mulAcctRcptLabel.gstAmount"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:-9999999999999.99|mask_min_value:0.00'"
                                @blur="calculateAmount()"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctRcptForm.netAmountCurr"
                                :label="mulAcctRcptLabel.netAmountCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctRcptForm.netAmountCurr"
                                :data-vv-as="mulAcctRcptLabel.netAmountCurr"
                                :error-messages="errors.collect('mulAcctRcptForm.netAmountCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.netAmount"
                                :disabled="true"
                                :label="mulAcctRcptLabel.netAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                :error-messages="errors.collect('mulAcctRcptForm.netAmount')"
                                data-vv-name="mulAcctRcptForm.netAmount"
                                :data-vv-as="mulAcctRcptLabel.netAmount"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:-9999999999999.99'"
                                @blur="calculateAmount()"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex md3 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctRcptForm.bankAmountCurr"
                                :label="mulAcctRcptLabel.bankAmountCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctRcptForm.bankAmountCurr"
                                :data-vv-as="mulAcctRcptLabel.bankAmountCurr"
                                :error-messages="errors.collect('mulAcctRcptForm.bankAmountCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox color="primary" v-model="mulAcctRcptForm.bankAmountAE" @change="calculateAmount()"></v-checkbox>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="bankAmount"
                                v-model="mulAcctRcptForm.bankAmount"
                                :disabled="isBankAmount"
                                :label="mulAcctRcptLabel.bankAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                :error-messages="errors.collect('mulAcctRcptForm.bankAmount')"
                                data-vv-name="mulAcctRcptForm.bankAmount"
                                :data-vv-as="mulAcctRcptLabel.bankAmount"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:-9999999999999.99|mask_min_value:0.00'"
                                @blur="calculateAmount()"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctRcptForm.bankChargesCurr"
                                :label="mulAcctRcptLabel.bankChargesCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctRcptForm.bankChargesCurr"
                                :data-vv-as="mulAcctRcptLabel.bankChargesCurr"
                                :error-messages="errors.collect('mulAcctRcptForm.bankChargesCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="bankCharges"
                                v-model="mulAcctRcptForm.bankCharges"
                                :label="mulAcctRcptLabel.bankCharges"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                :error-messages="errors.collect('mulAcctRcptForm.bankCharges')"
                                data-vv-name="mulAcctRcptForm.bankCharges"
                                :data-vv-as="mulAcctRcptLabel.bankCharges"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99'"
                                @blur="calculateAmount()"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctRcptForm.bankTotalAmountCurr"
                                :label="mulAcctRcptLabel.bankTotalAmountCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctRcptForm.bankTotalAmountCurr"
                                :data-vv-as="mulAcctRcptLabel.bankTotalAmountCurr"
                                :error-messages="errors.collect('mulAcctRcptForm.bankTotalAmountCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="bankTotalAmount"
                                v-model="mulAcctRcptForm.bankTotalAmount"
                                :disabled="true"
                                :label="mulAcctRcptLabel.bankTotalAmount"
                                :error-messages="errors.collect('mulAcctRcptForm.bankTotalAmount')"
                                data-vv-name="mulAcctRcptForm.bankTotalAmount"
                                :data-vv-as="mulAcctRcptLabel.bankTotalAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md3 xs12>
                               <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctRcptForm.bankTotalLocalCurr"
                                :label="mulAcctRcptLabel.bankTotalLocalCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctRcptForm.bankTotalLocalCurr"
                                :data-vv-as="mulAcctRcptLabel.bankTotalLocalCurr"
                                :error-messages="errors.collect('mulAcctRcptForm.bankTotalLocalCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                v-model="mulAcctRcptForm.bankTotalLocalAE"
                                @change="calculateAmount()"
                                :disabled="isEqualAmtCurr"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="bankTotalLocal"
                                v-model="mulAcctRcptForm.bankTotalLocal"
                                :disabled="isBankTotalLocal"
                                :label="mulAcctRcptLabel.bankTotalLocal"
                                :error-messages="errors.collect('mulAcctRcptForm.bankTotalLocal')"
                                data-vv-name="mulAcctRcptForm.bankTotalLocal"
                                :data-vv-as="mulAcctRcptLabel.bankTotalLocal"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.00'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-if="isNew">
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ createdName + ' on ' + nowDT }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-else>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.createdBy + ' on ' + mulAcctRcptForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-if="isNew">
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ createdName + ' on ' + nowDT }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-else>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.modifiedBy + ' on ' + mulAcctRcptForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional" eager>
                <form data-vv-scope="receiptsOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="printDocOptions"
                                v-model="mulAcctRcptForm.printDocument"
                                :label="mulAcctRcptLabel.printDocument"
                                item-text="label"
                                item-value="value"
                                data-vv-name="printDocument"
                                :data-vv-as="mulAcctRcptLabel.printDocument"
                                :error-messages="errors.collect('printDocument')"
                                :disabled="this.defaultForm.isDisabled"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="addressToOptions"
                                v-model="mulAcctRcptForm.addressTo"
                                :label="mulAcctRcptLabel.addressTo"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctRcptForm.addressTo"
                                :data-vv-as="mulAcctRcptLabel.addressTo"
                                :error-messages="errors.collect('mulAcctRcptForm.addressTo')"
                                @change="promptRemoveNameAddr = true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.policyNo"
                                :label="mulAcctRcptLabel.policyNo"
                                :error-messages="errors.collect('policyNo')"
                                data-vv-name="policyNo"
                                :data-vv-as="mulAcctRcptLabel.policyNo"
                                :maxlength="16"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showAcctPolicyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.companyName"
                                :label="mulAcctRcptLabel.companyName"
                                :error-messages="errors.collect('receiptsOptionalForm.companyName')"
                                data-vv-name="companyName"
                                :data-vv-as="mulAcctRcptLabel.companyName"
                                v-validate="'entry|max:100|sanction:' + sanctionName1Error"
                                @change="valSanction(mulAcctRcptForm.companyName, '', 'sanctionName1Error')"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.docAddress1"
                                :label="mulAcctRcptLabel.docAddress1"
                                :error-messages="errors.collect('docAddress1')"
                                data-vv-name="docAddress1"
                                :data-vv-as="mulAcctRcptLabel.docAddress1"
                                :maxlength="60"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.docAddress2"
                                :label="mulAcctRcptLabel.docAddress2"
                                :error-messages="errors.collect('docAddress2')"
                                data-vv-name="docAddress2"
                                :data-vv-as="mulAcctRcptLabel.docAddress2"
                                :maxlength="60"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.docAddress3"
                                :label="mulAcctRcptLabel.docAddress3"
                                :error-messages="errors.collect('docAddress3')"
                                data-vv-name="docAddress3"
                                :data-vv-as="mulAcctRcptLabel.docAddress3"
                                :maxlength="60"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.docAddress4"
                                :label="mulAcctRcptLabel.docAddress4"
                                :error-messages="errors.collect('docAddress4')"
                                data-vv-name="docAddress4"
                                :data-vv-as="mulAcctRcptLabel.docAddress4"
                                :maxlength="60"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.postalCode"
                                :label="mulAcctRcptLabel.postalCode"
                                :error-messages="errors.collect('postalCode')"
                                data-vv-name="postalCode"
                                :data-vv-as="mulAcctRcptLabel.postalCode"
                                :maxlength="8"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-textarea
                                v-model="mulAcctRcptForm.details"
                                :label="mulAcctRcptLabel.details"
                                no-resize
                                rows="3"
                                :error-messages="errors.collect('details')"
                                data-vv-name="details"
                                :data-vv-as="mulAcctRcptLabel.details"
                                :maxlength="120"
                              ></v-textarea>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-textarea
                                v-model="mulAcctRcptForm.statementRef"
                                :label="mulAcctRcptLabel.statementRef"
                                no-resize
                                rows="3"
                                :error-messages="errors.collect('statementRef')"
                                data-vv-name="statementRef"
                                :data-vv-as="mulAcctRcptLabel.statementRef"
                                :maxlength="200"
                              ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="departments"
                                v-model="mulAcctRcptForm.department"
                                :label="mulAcctRcptLabel.department"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctRcptForm.department"
                                :data-vv-as="mulAcctRcptLabel.department"
                                :error-messages="errors.collect('mulAcctRcptForm.department')"
                                v-validate="departmentValidate"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.insuredName"
                                :label="mulAcctRcptLabel.insuredName"
                                :error-messages="errors.collect('insuredName')"
                                data-vv-name="insuredName"
                                :data-vv-as="mulAcctRcptLabel.insuredName"
                                :maxlength="60"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.claimNo"
                                :label="mulAcctRcptLabel.claimNo"
                                :error-messages="errors.collect('claimNo')"
                                data-vv-name="claimNo"
                                :data-vv-as="mulAcctRcptLabel.claimNo"
                                :maxlength="12"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showClmHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.gstRegNo"
                                :label="mulAcctRcptLabel.gstRegNo"
                                :error-messages="errors.collect('gstRegNo')"
                                data-vv-name="gstRegNo"
                                :data-vv-as="mulAcctRcptLabel.gstRegNo"
                                :maxlength="20"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.taxInvoiceNo"
                                :label="mulAcctRcptLabel.taxInvoiceNo"
                                :error-messages="errors.collect('taxInvoiceNo')"
                                data-vv-name="taxInvoiceNo"
                                :data-vv-as="mulAcctRcptLabel.taxInvoiceNo"
                                :maxlength="30"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="paymentmethod" eager>
                <form data-vv-scope="receiptsPaymentForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="payerbanks"
                                :disabled="isPayBank || this.defaultForm.isDisabled"
                                v-model="mulAcctRcptForm.payerBank"
                                :label="mulAcctRcptLabel.payerBank"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctRcptForm.payerBank"
                                :data-vv-as="mulAcctRcptLabel.payerBank"
                                :error-messages="errors.collect('mulAcctRcptForm.payerBank')"
                                v-validate="payerBankValidate"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.payersChequeNo"
                                :disabled="isChequeNo || this.defaultForm.isDisabled"
                                :label="mulAcctRcptLabel.payersChequeNo"
                                :error-messages="errors.collect('mulAcctRcptForm.payersChequeNo')"
                                data-vv-name="mulAcctRcptForm.payersChequeNo"
                                :data-vv-as="mulAcctRcptLabel.payersChequeNo"
                                :maxlength="10"
                                v-validate="payChqNoValidate"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.drawerName"
                                :disabled="isDrawerName || this.defaultForm.isDisabled"
                                :label="mulAcctRcptLabel.drawerName"
                                :error-messages="errors.collect('mulAcctRcptForm.drawerName')"
                                data-vv-name="mulAcctRcptForm.drawerName"
                                :data-vv-as="mulAcctRcptLabel.drawerName"
                                :maxlength="50"
                                v-validate="drawerNameValidate"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="mulAcctRcptForm.creditCardNo"
                                :disabled="isCreditCardNo || this.defaultForm.isDisabled"
                                :label="mulAcctRcptLabel.creditCardNo"
                                :error-messages="errors.collect('mulAcctRcptForm.creditCardNo')"
                                data-vv-name="mulAcctRcptForm.creditCardNo"
                                :data-vv-as="mulAcctRcptLabel.creditCardNo"
                                :maxlength="20"
                                v-validate="creditCardNoValidate"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>

            <v-flex xs12 v-if="this.btnSaveList === false">
              <v-btn color="primary" dark @click.prevent="doAddAccount" :loading="submitting">
                {{ actionLabel.addAccount }}
                <v-icon dark right>mdi-plus</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.btnSaveList === true">
              <v-card-actions>
                <v-btn color="error" dark @click.prevent="doCancelAccount" :loading="submitting">
                  {{ actionLabel.cancelAccount }}
                  <v-icon dark right>mdi-close</v-icon>
                </v-btn>
                <v-btn color="primary" dark @click.prevent="doSaveAccount" :loading="submitting">
                  {{ actionLabel.saveAccount }}
                  <v-icon dark right>mdi-content-save</v-icon>
                </v-btn>
              </v-card-actions>
            </v-flex>
            <v-flex xs12 class="mt-3">
              <v-card>
                <v-data-table
                  v-bind:headers="listMulAcctRcptHeaders"
                  v-bind:items="accountList"
                  item-key="key"
                  :loading="loading"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectAcctRcptColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doRemove(row)"></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3><u>Grand Total </u></h3>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.receipt"
                          :label="grandTotLabel.receipt"
                          disabled
                          :error-messages="errors.collect('grandTotForm.receipt')"
                          data-vv-name="grandTotForm.receipt"
                          :data-vv-as="grandTotLabel.receipt"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.gst"
                          :label="grandTotLabel.gst"
                          disabled
                          :error-messages="errors.collect('grandTotForm.gst')"
                          data-vv-name="grandTotForm.gst"
                          :data-vv-as="grandTotLabel.gst"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.net"
                          :label="grandTotLabel.net"
                          disabled
                          :error-messages="errors.collect('grandTotForm.net')"
                          data-vv-name="grandTotForm.net"
                          :data-vv-as="grandTotLabel.net"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.bankAmt"
                          :label="grandTotLabel.bankAmt"
                          disabled
                          :error-messages="errors.collect('grandTotForm.bankAmt')"
                          data-vv-name="grandTotForm.bankAmt"
                          :data-vv-as="grandTotLabel.bankAmt"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.charges"
                          :label="grandTotLabel.charges"
                          disabled
                          :error-messages="errors.collect('grandTotForm.charges')"
                          data-vv-name="grandTotForm.charges"
                          :data-vv-as="grandTotLabel.charges"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.total"
                          :label="grandTotLabel.total"
                          disabled
                          :error-messages="errors.collect('grandTotForm.total')"
                          data-vv-name="grandTotForm.total"
                          :data-vv-as="grandTotLabel.total"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.localTotal"
                          :label="grandTotLabel.localTotal"
                          disabled
                          :error-messages="errors.collect('grandTotForm.localTotal')"
                          data-vv-name="grandTotForm.localTotal"
                          :data-vv-as="grandTotLabel.localTotal"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-card-actions>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn color="info" dark @click.prevent="doSaveReceipt('CREATE_SAVE_REVIEW')" :loading="submitting">
                {{ actionLabel.saveAndReview }}
                <v-icon dark right>mdi-content-save</v-icon>
              </v-btn>
              <v-btn color="primary" dark @click.prevent="doSaveReceipt('CREATE_SAVE_POST')" :loading="submitting">
                {{ actionLabel.saveAndPost }}
                <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-dialog v-model="showCurrHelpList" width="1280px">
          <currency-help-list @close="showCurrHelpList = false" @assign-currency-info="assignCurrencyInfo"></currency-help-list>
        </v-dialog>

        <v-dialog v-model="showAcctNoHelpList" width="1280px">
          <acct-no-help-list
            @close="showAcctNoHelpList = false"
            @assign-acct-info="assignAcctInfo"
            :boolRefresh="showAcctNoHelpList"
          ></acct-no-help-list>
        </v-dialog>

        <v-dialog v-model="showBankNoHelpList" width="1280px">
          <bank-help-list
            @close="showBankNoHelpList = false"
            @assign-bank-info="assignBankInfo"
            :boolRefresh="showBankNoHelpList"
            :objData="bankHelpListScreen"
          ></bank-help-list>
        </v-dialog>

        <v-dialog v-model="showAcctSufHelpList" width="1280px">
          <acct-suf-help-list @close="showAcctSufHelpList = false" @assign-acct-suf-info="assignAcctSufInfo"></acct-suf-help-list>
        </v-dialog>

        <v-dialog v-model="showAcctPolicyHelpList" width="1280px">
          <acct-policy-help-list
            :accountNo="mulAcctRcptForm.accountNo"
            :boolPolRefresh="showAcctPolicyHelpList"
            @close="showAcctPolicyHelpList = false"
            @assign-policy-info="assignPolicyInfo"
          ></acct-policy-help-list>
        </v-dialog>

        <v-dialog v-model="showClmHelpList" width="1280px">
          <claim-help-list
            @close="showClmHelpList = false"
            @assign-claim-no="assignClaimNo"
            :boolRefresh="showClmHelpList"
            :accountNo="mulAcctRcptForm.accountNo"
          ></claim-help-list>
        </v-dialog>

        <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
        <v-dialog v-model="showSanctionDialog" width="1280px">
          <sanction-partial-match-list :sanctionItems="sanctionPartialMatchItems" @close="showSanctionDialog = false"></sanction-partial-match-list>
        </v-dialog>

        <v-dialog v-model="processingFlag" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Processing...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <warning v-model="promptMsg" :label="errMsg" :showAcceptBtn="isWarning" @ok="acceptInterWarn = true"/>
        <v-dialog v-model="showErrorDialog" width="800px">
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-information</v-icon>
              <v-toolbar-title>System Information</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <div v-if="messages.length > 0" class="pb-3">
                <span class="info-dialog-msg-header">Oops something went wrong...</span>
                <v-spacer class="mt-2"></v-spacer>
                <ul class="showErrorMsgs">
                  <li v-for="(error, index) in messages" :key="index">
                    {{ error.message }}
                  </li>
                </ul>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <warning v-model="promptDuplicateAccount">
          <p>This Account No and Suffix already created</p>
          Account No.: {{ duplicateForm.acctNo }}<br />
          Suffix: {{ duplicateForm.suffix }}
        </warning>
        <prompt-leave
          v-if="showPromptLeave"
          title="Multiple Account Receipt"
          v-model="promptLeave"
          @exit="doExit"
          @saveAndExit="doSaveAndExit"
        ></prompt-leave>

        <confirm v-model="promptConfirmation" @ok="doProceed" @cancel="processingFlag = false">
          <p>Cheque No. is existing in other receipt, do you want to proceed?</p>
          <div class="queryValue">
            Bank No. : {{ this.mulAcctRcptForm.bankNo }}<br />
            Cheque No. : {{ this.mulAcctRcptForm.payersChequeNo }}<br />
          </div>
        </confirm>
        <confirm v-model="promptRemoveNameAddr" @ok="doRemoveNameAddr">
          {{ promptRemoveNameAddrMsg }}
        </confirm>
      </v-layout>
    </v-container>

    <warning v-model="promptWarning" :label="warningMsg" :info="true"/>

    <v-dialog v-model="loadingFlag" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { mulAcctReceiptViewMixin } from '@/mixins/accounting/receipts/mulAcctRcpt/mulAcctReceiptViewMixin'
import { mulAcctReceiptAjaxMixin } from '@/mixins/accounting/receipts/mulAcctRcpt/mulAcctReceiptAjaxMixin'
import { receiptsAjaxMixin } from '@/mixins/accounting/receipts/receiptsAjaxMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import CurrencyHelpList from '@/components/core/common/dialog/CurrencyHelpList'
import AcctNoHelpList from '@/components/core/common/dialog/AcctNoHelpList'
import BankHelpList from '@/components/core/common/dialog/BankHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import AcctPolicyHelpList from '@/components/core/common/dialog/AcctPolicyHelpList'
import ClaimHelpList from '@/components/core/common/dialog/ClaimHelpList'
import { removeFormatNumber } from '@/utils/number'
import { promptOnExitMixin } from '@/mixins/common/promptOnExitMixin'
import PromptLeave from '@/components/core/common/prompt/PromptLeave'
import { formatPrice } from '@/utils/index'
import { parseISO } from 'date-fns'
import { formatDisplayDateTime2 } from '@/utils/date'
import * as TableConst from '@/mixins/table'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'

export default {
  data() {
    return {
      receiptTabs: ['Mandatory', 'Optional', 'Payment Method'],
      tabsNav: 0,
      loading: false,
      loadingFlag: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      branches: [],
      currencies: [],
      payerbanks: [],
      paymentmethods: [],
      departments: [],
      cashbooks: [],
      banks: [],
      miscacctparams: [],
      accounts: [],
      amountcurrencies: [],
      acctnosuffixes: [],
      funds: [],
      acctnosuffixdata: {},
      amountcurrencydata: {},
      paymentmethod: {},
      accountdata: {},
      bankdata: {},
      trandaterange: {},
      showCurrHelpList: false,
      showAcctNoHelpList: false,
      showBankNoHelpList: false,
      showAcctSufHelpList: false,
      showAcctPolicyHelpList: false,
      showClmHelpList: false,
      gstIOOptions: [
        { value: 'B', label: '' },
        { value: 'I', label: 'I - Input' },
        { value: 'O', label: 'O - Output' }
      ],
      printDocOptions: [
        { value: 'I', label: 'I - Immediately' },
        { value: 'L', label: 'L - Later' },
        { value: 'N', label: 'N - No' }
      ],
      addressToOptions: [
        { value: 'A', label: 'A - Agent' },
        { value: 'I', label: 'I - Insured' },
        { value: 'E', label: 'E - Entered ad below' }
      ],
      actionLabel: {
        cancel: 'Cancel',
        saveAndReview: 'Save & Review',
        saveAndPost: 'Save & Post',
        matchLater: 'Match Later',
        addAccount: 'Add Account',
        saveAccount: 'Save & Continue',
        cancelAccount: 'Cancel'
      },
      validStatus: {
        mandatory: true,
        optional: true,
        paymentmethod: true
      },
      receiptErrors: [],
      gstStatuses: [],
      gstrate: '0.00',
      promptConfirmation: false,
      isExistChequeNo: false,
      grandTotLabel: {
        receipt: 'Receipt',
        gst: 'GST',
        net: 'Net',
        bankAmt: 'Bank Amt',
        charges: 'Charges',
        total: 'Total',
        localTotal: 'Local Total'
      },
      grandTotForm: {
        receipt: '0.00',
        gst: '0.00',
        net: '0.00',
        bankAmt: '0.00',
        charges: '0.00',
        total: '0.00',
        localTotal: '0.00'
      },
      defaultForm: {
        branch: null,
        documentNo: null,
        transactionType: null,
        docAE: true,
        transactionDateDisp: null,
        payerBank: null,
        paymentMethod: null,
        payersChequeNo: null,
        drawerName: null,
        creditCardNo: null,
        depositAcct: null,
        fund: null,
        gstIO: null,
        gstStatus: null,
        gstRate: (0.0).toFixed(2),
        amountCurr: null,
        bankAmountCurr: null,
        bankAmountCurrRate: (0.0).toFixed(2),
        amountCurrRate: (0.0).toFixed(2),
        bankChargesCurr: null,
        bankTotalAmountCurr: null,
        bankTotalLocalCurr: null,
        printDocument: null,
        isDisabled: false
      },
      duplicateForm: {
        acctNo: null,
        suffix: null
      },
      reviewForm: {
        accountNo: null,
        accountNoSuffix: null,
        branch: null,
        documentNo: null,
        fund: null,
        transactionType: null
      },
      existAcctRcpt: false,
      promptDuplicateAccount: false,
      headerPanel: [0],
      menu: {},
      promptWarning: false,
      initDisabled: false,
      isEqualAmtCurr: false,
      promptRemoveNameAddr: false,
      promptRemoveNameAddrMsg: 'Do you want to remove Name, Address(1-4), Postal Code?',
      warningMsg: ''
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    payChqNoValidate: {
      handler: function(isMandatory) {
        if (isMandatory) {
          this.mulAcctRcptLabel.payersChequeNo = 'Cheque No*'
        } else {
          this.mulAcctRcptLabel.payersChequeNo = 'Cheque No'
        }
      }
    },
    payerBankValidate: {
      handler: function(isMandatory) {
        if (isMandatory) {
          this.mulAcctRcptLabel.payerBank = 'Payer Bank*'
        } else {
          this.mulAcctRcptLabel.payerBank = 'Payer Bank'
        }
      }
    },
    drawerNameValidate: {
      handler: function(isMandatory) {
        if (isMandatory) {
          this.mulAcctRcptLabel.drawerName = 'Drawer Name*'
        } else {
          this.mulAcctRcptLabel.drawerName = 'Drawer Name'
        }
      }
    },
    creditCardNoValidate: {
      handler: function(isMandatory) {
        if (isMandatory) {
          this.mulAcctRcptLabel.creditCardNo = 'Credit Card No*'
        } else {
          this.mulAcctRcptLabel.creditCardNo = 'Credit Card No'
        }
      }
    },
    departmentValidate: {
      handler: function(isMandatory) {
        if (isMandatory) {
          this.mulAcctRcptLabel.department = 'Department*'
        } else {
          this.mulAcctRcptLabel.department = 'Department'
        }
      }
    },
    'tDateRange.effDate': function() {
      if (this.tDateRange.effDate !== '' && this.receiptData.tranMode === '') {
        this.getCommonData('gstrate', this.mulAcctRcptForm.gstStatus, formatDisplayDateTime2(this.mulAcctRcptForm.transactionDateDisp))
      }
    },
    'mulAcctRcptForm.amountCurr': function() {
      if (this.mulAcctRcptForm.amountCurr && this.mulAcctRcptForm.transactionDateDisp) {
        this.getCommonData('currencyrate', this.mulAcctRcptForm.amountCurr, formatDisplayDateTime2(this.mulAcctRcptForm.transactionDateDisp))
      }
    }
  },
  computed: {
    mulAcctRcptMenu() {
      return this.$store.state.receipt.menu
    },
    receiptData() {
      return this.$store.state.receipt.receiptData
    },
    displayErrorDialog() {
      return this.messages
    },
    isGstAmtAE: function() {
      if (this.mulAcctRcptForm.gstIO === 'B') {
        return true
      } else {
        return false
      }
    },
    isDisabledDocNo: function() {
      return this.mulAcctRcptForm.docAE
    },
    isGstAmount: function() {
      return this.mulAcctRcptForm.gstAmountAE
    },
    isBankAmount: function() {
      return this.mulAcctRcptForm.bankAmountAE
    },
    isBankTotalLocal: function() {
      if (this.isEqualAmtCurr) {
        return true
      } else {
        return this.mulAcctRcptForm.bankTotalLocalAE
      }
    },
    isCreditCardNo: function() {
      return this.paymentmethod.crcdNo !== 'M' && this.paymentmethod.crcdNo !== 'O'
    },
    isDrawerName: function() {
      return this.paymentmethod.drawName !== 'M' && this.paymentmethod.drawName !== 'O'
    },
    isChequeNo: function() {
      return this.paymentmethod.payChqNo !== 'M' && this.paymentmethod.payChqNo !== 'O'
    },
    isPayBank: function() {
      return this.paymentmethod.payBank !== 'M' && this.paymentmethod.payBank !== 'O'
    },
    isCashBook: function() {
      return this.miscacctparams.cashBkMand === null || this.miscacctparams.cashBkMand === false
    },
    payChqNoValidate() {
      if (this.paymentmethod.payChqNo === 'M') {
        return 'required'
      } else {
        return ''
      }
    },
    payerBankValidate() {
      if (this.paymentmethod.payBank === 'M') {
        return 'required'
      } else {
        return ''
      }
    },
    drawerNameValidate() {
      if (this.paymentmethod.drawName === 'M') {
        return 'required'
      } else {
        return ''
      }
    },
    creditCardNoValidate() {
      if (this.paymentmethod.crcdNo === 'M') {
        return 'required'
      } else {
        return ''
      }
    },
    departmentValidate() {
      if (this.miscacctparams.deptMand) {
        return 'required'
      } else {
        return ''
      }
    },
    tDateRange() {
      return this.trandaterange
    },
    docNoValidation() {
      if (this.mulAcctRcptForm.docAE === false && (this.mulAcctRcptForm.documentNo === null || this.mulAcctRcptForm.documentNo === '')) {
        return 'required'
      } else {
        return 'entry|documentNo:' + this.mulAcctRcptForm.isExistDocNo
      }
    },
    listMulAcctRcptHeaders() {
      let result = []
      for (const selectAcctRcptColumns of this.selectAcctRcptColumns) {
        let findCol = this.mulAcctRcptColumns.find(a => selectAcctRcptColumns === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    isNew() {
      return !(this.receiptData.tranMode === 'Q' || this.receiptData.tranMode === 'R')
    }
  },
  methods: {
    changeGstIO(gstIO) {
      this.mulAcctRcptForm.gstIO = gstIO
      if (this.mulAcctRcptForm.gstIO === 'B') {
        this.mulAcctRcptForm.gstStatus = 'B'
        this.mulAcctRcptForm.gstAmount = this.defaultAmount()
        this.mulAcctRcptForm.gstRate = this.defaultAmount()
      } else {
        this.mulAcctRcptForm.gstStatus = 'M'
        this.getCommonData('gstrate', this.mulAcctRcptForm.gstStatus, formatDisplayDateTime2(this.mulAcctRcptForm.transactionDateDisp))
        // this.mulAcctRcptForm.gstRate = (7.00).toFixed(2)
      }
      this.calculateAmount()
    },
    calculateAmount() {
      let bankAmt = 0.0
      let bankTotAmt = 0.0
      // let bankCharges = 0.00
      if (this.mulAcctRcptForm.depositAcct !== null) {
        if (this.mulAcctRcptForm.gstAmountAE) {
          // Only if GST Rate is not equal to zero (0), then GST Amount = Amount * GSTRate/100
          this.mulAcctRcptForm.gstAmount = formatPrice((removeFormatNumber(this.mulAcctRcptForm.amount) * this.mulAcctRcptForm.gstRate) / 100)
        }
        /*
          If GSTIO = Blank then Net Amount = Amount.
          If GSTIO = I then Net Amount = Amount – GST Amount
          If GSTIO = O then Net Amount = Amount + GST Amount
        */
        if (this.mulAcctRcptForm.gstIO === 'B') {
          this.mulAcctRcptForm.netAmount = formatPrice(Number(removeFormatNumber(this.mulAcctRcptForm.amount)))
        }
        if (this.mulAcctRcptForm.gstIO === 'I') {
          this.mulAcctRcptForm.netAmount = formatPrice(
            removeFormatNumber(this.mulAcctRcptForm.amount) - Number(removeFormatNumber(this.mulAcctRcptForm.gstAmount))
          )
        }
        if (this.mulAcctRcptForm.gstIO === 'O') {
          this.mulAcctRcptForm.netAmount = formatPrice(
            Number(removeFormatNumber(this.mulAcctRcptForm.amount)) + Number(removeFormatNumber(this.mulAcctRcptForm.gstAmount))
          )
        }
        if (this.mulAcctRcptForm.bankAmountAE) {
          // Bank Amount = (Net Amount * Net Amount Currency Rate) / Bank Amount Currency Rate
          this.mulAcctRcptForm.bankAmount = formatPrice(
            (removeFormatNumber(this.mulAcctRcptForm.netAmount) * this.mulAcctRcptForm.amountCurrRate) / this.mulAcctRcptForm.bankAmountCurrRate
          )
        }
        // Bank Amount - Bank Charges
        this.mulAcctRcptForm.bankTotalAmount = formatPrice(
          removeFormatNumber(this.mulAcctRcptForm.bankAmount) - removeFormatNumber(this.mulAcctRcptForm.bankCharges)
        )
        if (this.mulAcctRcptForm.bankTotalLocalAE) {
          //  ONLY IF bankTotalLocalAE is checked. Bank Amount * Bank Total Amount currency rate
          // this.mulAcctRcptForm.bankTotalLocal = (removeFormatNumber(this.mulAcctRcptForm.bankTotalAmount) * this.mulAcctRcptForm.bankAmountCurrRate).toFixed(2)
          // this.mulAcctRcptForm.bankTotalLocal = formatPrice(removeFormatNumber(this.mulAcctRcptForm.bankTotalAmount) * this.mulAcctRcptForm.bankTotalLocalCurrRate)
          // this.mulAcctRcptForm.bankTotalLocal = formatPrice(removeFormatNumber(this.mulAcctRcptForm.bankTotalAmount) * this.mulAcctRcptForm.bankAmountCurrRate)
          // bankAmt = ((removeFormatNumber(this.mulAcctRcptForm.netAmount) * this.mulAcctRcptForm.amountCurrRate) / this.mulAcctRcptForm.bankAmountCurrRate)
          // bankCharges = Number(this.mulAcctRcptForm.bankCharges).toFixed(3)
          // bankTotAmt = Number(bankAmt).toFixed(3) - Number(bankCharges)
          // this.mulAcctRcptForm.bankTotalLocal = formatPrice(bankTotAmt * Number(this.mulAcctRcptForm.bankAmountCurrRate))
          if (this.mulAcctRcptForm.bankAmountAE) {
            bankAmt =
              (Number(removeFormatNumber(this.mulAcctRcptForm.netAmount)) * Number(removeFormatNumber(this.mulAcctRcptForm.amountCurrRate))) /
              Number(removeFormatNumber(this.mulAcctRcptForm.bankAmountCurrRate))
          } else {
            bankAmt = removeFormatNumber(this.mulAcctRcptForm.bankAmount)
          }
          bankTotAmt = Number(bankAmt) - Number(removeFormatNumber(this.mulAcctRcptForm.bankCharges))
          bankTotAmt = bankTotAmt * Number(this.mulAcctRcptForm.bankAmountCurrRate)
          this.mulAcctRcptForm.bankTotalLocal = formatPrice(bankTotAmt)
        }
      }
      this.setAmount()
    },
    setAmount() {
      this.$refs.amount.$el.cleave.setRawValue(this.mulAcctRcptForm.amount)
      this.mulAcctRcptForm.amount = formatPrice(this.$refs.amount.$el.cleave.getRawValue())
      this.$refs.gstAmount.$el.cleave.setRawValue(this.mulAcctRcptForm.gstAmount)
      this.mulAcctRcptForm.gstAmount = formatPrice(this.$refs.gstAmount.$el.cleave.getRawValue())
      this.$refs.bankAmount.$el.cleave.setRawValue(this.mulAcctRcptForm.bankAmount)
      this.mulAcctRcptForm.bankAmount = formatPrice(this.$refs.bankAmount.$el.cleave.getRawValue())
      this.$refs.bankCharges.$el.cleave.setRawValue(this.mulAcctRcptForm.bankCharges)
      this.mulAcctRcptForm.bankCharges = formatPrice(this.$refs.bankCharges.$el.cleave.getRawValue())
      this.$refs.bankTotalLocal.$el.cleave.setRawValue(this.mulAcctRcptForm.bankTotalLocal)
      this.mulAcctRcptForm.bankTotalLocal = formatPrice(this.$refs.bankTotalLocal.$el.cleave.getRawValue())
      this.$refs.bankTotalAmount.$el.cleave.setRawValue(this.mulAcctRcptForm.bankTotalAmount)
      this.mulAcctRcptForm.bankTotalAmount = formatPrice(this.$refs.bankTotalAmount.$el.cleave.getRawValue())
    },
    currencyChange() {
      this.mulAcctRcptForm.gstAmountCurr = this.mulAcctRcptForm.amountCurr
      this.mulAcctRcptForm.netAmountCurr = this.mulAcctRcptForm.amountCurr
    },
    checkDocAE(event) {
      if (event) {
        this.mulAcctRcptForm.documentNo = null
        this.resetMessages()
        this.resetValidator()
      }
    },
    changeGstRate(gstStatus) {
      this.getCommonData('gstrate', gstStatus, formatDisplayDateTime2(this.mulAcctRcptForm.transactionDateDisp))
    },
    assignAcctSufInfo(data) {
      this.mulAcctRcptForm.accountNoSuffixDesc = data.acctNoSfx
      this.mulAcctRcptForm.accountNoSuffix = data.acctNoSfx
      this.showAcctSufHelpList = false
    },
    assignCurrencyInfo(data) {
      this.mulAcctRcptForm.amountCurr = data.curr
      this.mulAcctRcptForm.gstAmountCurr = data.curr
      this.mulAcctRcptForm.netAmountCurr = data.curr
      this.mulAcctRcptForm.amountCurrRate = data.currRate
      this.showCurrHelpList = false
      this.calculateAmount()
    },
    assignAcctInfo(data) {
      this.mulAcctRcptForm.accountNo = data.inter
      this.mulAcctRcptForm.receivedFrom = data.inter
      if (this.mulAcctRcptForm.addressTo === 'A') {
        this.mulAcctRcptForm.gstRegNo = data.gstRegNo
        this.mulAcctRcptForm.docAddress1 = data.address1
        this.mulAcctRcptForm.docAddress2 = data.address2
        this.mulAcctRcptForm.docAddress3 = data.address3
        this.mulAcctRcptForm.docAddress4 = data.address4
        this.mulAcctRcptForm.companyName = data.name
        this.mulAcctRcptForm.postalCode = data.postalCode
      }
      this.showAcctNoHelpList = false
    },
    assignBankInfo(data) {
      this.mulAcctRcptForm.amountCurr = data.bankAcctCurrency
      this.mulAcctRcptForm.gstAmountCurr = data.bankAcctCurrency
      this.mulAcctRcptForm.netAmountCurr = data.bankAcctCurrency
      this.mulAcctRcptForm.bankAmountCurr = data.bankAcctCurrency
      this.mulAcctRcptForm.bankChargesCurr = data.bankAcctCurrency
      this.mulAcctRcptForm.bankTotalAmountCurr = data.bankAcctCurrency
      this.mulAcctRcptForm.fund = data.bankFund
      this.mulAcctRcptForm.accountNoSuffix = data.bankAcctNoSfx
      this.mulAcctRcptForm.paymentMethod = data.bankPaymentMethod
      this.mulAcctRcptForm.depositAcct = data.defPayBank
      this.mulAcctRcptForm.bankNo = data.defPayBank
      this.mulAcctRcptForm.bankAmountCurrRate = data.bankCurrRate
      this.mulAcctRcptForm.amountCurrRate = data.bankCurrRate
      this.showBankNoHelpList = false
      this.checkTotAmtCurrCompanyCurr()
      this.calculateAmount()
    },
    doRemoveNameAddr() {
      this.mulAcctRcptForm.companyName = ''
      this.mulAcctRcptForm.docAddress1 = ''
      this.mulAcctRcptForm.docAddress2 = ''
      this.mulAcctRcptForm.docAddress3 = ''
      this.mulAcctRcptForm.docAddress4 = ''
      this.mulAcctRcptForm.postalCode = ''
    },
    checkTotAmtCurrCompanyCurr() {
      if (this.mulAcctRcptForm.netAmountCurr === this.mulAcctRcptForm.bankTotalLocalCurr) {
        this.mulAcctRcptForm.bankTotalLocalAE = true
        this.isEqualAmtCurr = true
      } else {
        this.isEqualAmtCurr = false
      }
    },
    assignPolicyInfo(data) {
      this.mulAcctRcptForm.policyNo = data.policyNo + '-' + data.renCnt + '-' + data.endtCnt
      this.mulAcctRcptForm.insuredName = data.insuredName
      this.mulAcctRcptForm.insdRefNo = data.insdRefNo
      if (this.mulAcctRcptForm.addressTo === 'I') {
        this.mulAcctRcptForm.companyName = data.fullName
        this.mulAcctRcptForm.docAddress1 = data.address1
        this.mulAcctRcptForm.docAddress2 = data.address2
        this.mulAcctRcptForm.docAddress3 = data.address3
        this.mulAcctRcptForm.docAddress4 = data.address4
        this.mulAcctRcptForm.postalCode = data.postalCode
      }
      this.showAcctPolicyHelpList = false
    },
    assignClaimNo(claimNo) {
      this.mulAcctRcptForm.claimNo = claimNo
      this.showClmHelpList = false
    },
    assignGSTRate(data) {
      this.mulAcctRcptForm.gstRate = formatPrice(data)
      this.calculateAmount()
    },
    defaultAmount() {
      return (0.0).toFixed(2)
    },
    async doInit() {
      this.loadingFlag = true
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('receiptInit')])
      await Promise.all([this.$store.dispatch('reportsInit')])
      await Promise.all([this.$store.dispatch('acctReportsInit')])
      this.getAcctRptMenuLink()
      this.getCommonData('trandaterange', '003') // 003 = For Receipts
      this.bankHelpListScreen = 'screen_1'
      if (this.receiptData.tranMode === 'R') {
        await Promise.all([this.performReviewMultAcctRcpt()])
      } else {
        this.doLaunch()
      }
      this.fetchBranch()
      this.fetchFund()
      this.fetchAcctNoSfx()
      this.fetchAmountCurrency()
      this.fetchBank()
      this.fetchAccount()
      this.fetchCashBook()
      this.fetchDepartment()
      this.fetchPaymentMethod()
      this.fetchPayerBank()
      this.fetchCurrency()
      this.fetchGstStatus()
      this.loadingFlag = false
    },
    doLaunch() {
      this.initDisabled = false
      if (this.accountList.length === 0) {
        this.defaultForm.isDisabled = false
        this.headerPanel = [0]
        this.getDefaultBankNo(this.$store.state.token.userBranch, this.mulAcctRcptForm, 'receipt').then(result => {
          if (result) {
            this.getPaymentMethod(this.mulAcctRcptForm.paymentMethod)
            this.checkTotAmtCurrCompanyCurr()
          }
        })
        this.mulAcctRcptForm.transactionDateDisp = new Date()
        this.mulAcctRcptForm.transactionType = 'Y'
        this.mulAcctRcptForm.docAE = true
        this.mulAcctRcptForm.documentNoDisabled = true
        this.mulAcctRcptForm.gstIO = 'B'
        this.mulAcctRcptForm.gstStatus = 'N'
        this.mulAcctRcptForm.branch = this.$store.state.token.userBranch

        this.getCommonData('miscacctparams').then(result => {
          this.mulAcctRcptForm.printDocument = this.miscacctparams.defIlnrcpt
        })
        this.getBaseCurr(this.mulAcctRcptForm)
      } else {
        this.headerPanel = []
        this.mulAcctRcptForm.branch = this.defaultForm.branch
        this.mulAcctRcptForm.documentNo = this.defaultForm.documentNo
        this.mulAcctRcptForm.transactionType = this.defaultForm.transactionType
        this.mulAcctRcptForm.docAE = this.defaultForm.docAE
        this.mulAcctRcptForm.transactionDateDisp = this.defaultForm.transactionDateDisp
        this.mulAcctRcptForm.paymentMethod = this.defaultForm.paymentMethod
        this.mulAcctRcptForm.payerBank = this.defaultForm.payerBank
        this.mulAcctRcptForm.payersChequeNo = this.defaultForm.payersChequeNo
        this.mulAcctRcptForm.drawerName = this.defaultForm.drawerName
        this.mulAcctRcptForm.creditCardNo = this.defaultForm.creditCardNo
        this.mulAcctRcptForm.depositAcct = this.defaultForm.depositAcct
        this.mulAcctRcptForm.fund = this.defaultForm.fund
        this.mulAcctRcptForm.gstIO = this.defaultForm.gstIO
        this.mulAcctRcptForm.gstStatus = this.defaultForm.gstStatus
        this.mulAcctRcptForm.gstRate = this.defaultForm.gstRate
        this.mulAcctRcptForm.amountCurr = this.defaultForm.amountCurr
        this.mulAcctRcptForm.bankAmountCurr = this.defaultForm.bankAmountCurr
        this.mulAcctRcptForm.bankAmountCurrRate = this.defaultForm.bankAmountCurrRate
        this.mulAcctRcptForm.amountCurrRate = this.defaultForm.amountCurrRate
        this.mulAcctRcptForm.bankChargesCurr = this.defaultForm.bankChargesCurr
        this.mulAcctRcptForm.bankTotalAmountCurr = this.defaultForm.bankTotalAmountCurr
        this.mulAcctRcptForm.bankTotalLocalCurr = this.defaultForm.bankTotalLocalCurr
        this.mulAcctRcptForm.printDocument = this.defaultForm.printDocument
        this.checkCurrRate()
      }
      this.mulAcctRcptForm.gstAmountAE = true
      this.mulAcctRcptForm.bankAmountAE = true
      this.mulAcctRcptForm.bankTotalLocalAE = true
      this.mulAcctRcptForm.addressTo = 'A'
    },
    doGetDefaultBankNo() {
      this.getDefaultBankNo(this.mulAcctRcptForm.branch, this.mulAcctRcptForm, 'receipt').then(result => {
        if (result) {
          this.checkTotAmtCurrCompanyCurr()
        }
      })
    },
    async getPaymentMethod(payment) {
      this.getCommonData('paymentmethod', payment)
    },
    async getAcctInfo(acctNo) {
      this.getCommonData('accountdata', acctNo)
    },
    async getBankInfo(bankNo) {
      this.getCommonData('bankdata', bankNo, formatDisplayDateTime2(this.mulAcctRcptForm.transactionDateDisp))
    },
    assignCurrRate(currRate) {
      this.mulAcctRcptForm.amountCurrRate = currRate
      this.mulAcctRcptForm.gstAmountCurr = this.mulAcctRcptForm.amountCurr
      this.mulAcctRcptForm.netAmountCurr = this.mulAcctRcptForm.amountCurr
      this.calculateAmount()
    },
    assignBankCurrRate(data) {
      this.mulAcctRcptForm.bankAmountCurrRate = data.bankCurrRate
      this.calculateAmount()
    },
    checkCurrRate() {
      if (this.mulAcctRcptForm.amountCurr && this.mulAcctRcptForm.transactionDateDisp) {
        this.getCommonData('currencyrate', this.mulAcctRcptForm.amountCurr, formatDisplayDateTime2(this.mulAcctRcptForm.transactionDateDisp))
        this.getCommonData('bankcurrencyrate', this.mulAcctRcptForm.depositAcct, formatDisplayDateTime2(this.mulAcctRcptForm.transactionDateDisp))
      }
    },
    async getAcctNoSfxInfo(acctNoSfx) {
      this.getCommonData('acctnosuffixdata', acctNoSfx)
    },
    doCancel() {
      this.$router.push({ name: 'mulAcctReceipt' })
    },
    closeDialog() {
      this.promptWarning = false
    },
    checkDocNo() {
      this.isDocNoExist(this.mulAcctRcptForm)
    },
    checkChequeNo() {
      if (
        this.mulAcctRcptForm.payersChequeNo !== null &&
        this.mulAcctRcptForm.payersChequeNo !== '' &&
        (this.defaultForm.isDisabled === false || this.initDisabled)
      ) {
        this.getAcctMasterRcptChequeNo(this.mulAcctRcptForm).then(result => {
          if (result) {
            if (this.isExistChequeNo === 'true') {
              this.promptConfirmation = true
            } else {
              this.doValidateMulAcctForm()
            }
          }
        })
      } else {
        this.doValidateMulAcctForm()
      }
    },
    async doAddAccount() {
      this.processingFlag = true
      this.existAcctPay = false
      for (var i = 0; i < this.accountList.length; i++) {
        if (
          this.accountList[i].accountNo === this.mulAcctRcptForm.accountNo &&
          this.accountList[i].accountNoSuffix === this.mulAcctRcptForm.accountNoSuffix
        ) {
          this.duplicateForm.acctNo = this.mulAcctRcptForm.accountNo
          this.duplicateForm.suffix = this.mulAcctRcptForm.accountNoSuffix
          this.existAcctPay = true
        }
      }
      if (this.existAcctPay) {
        this.promptDuplicateAccount = true
        this.processingFlag = false
      } else {
        this.checkChequeNo()
      }
    },
    doProceedSaveMulAcct() {
      if (this.accountList.length <= 1) {
        this.defaultForm.isDisabled = true
        this.defaultForm.branch = this.mulAcctRcptForm.branch
        this.defaultForm.documentNo = this.mulAcctRcptForm.documentNo
        this.defaultForm.transactionType = this.mulAcctRcptForm.transactionType
        this.defaultForm.docAE = this.mulAcctRcptForm.docAE
        this.defaultForm.transactionDateDisp = this.mulAcctRcptForm.transactionDateDisp
        this.defaultForm.paymentMethod = this.mulAcctRcptForm.paymentMethod
        this.defaultForm.payerBank = this.mulAcctRcptForm.payerBank
        this.defaultForm.payersChequeNo = this.mulAcctRcptForm.payersChequeNo
        this.defaultForm.drawerName = this.mulAcctRcptForm.drawerName
        this.defaultForm.creditCardNo = this.mulAcctRcptForm.creditCardNo
        this.defaultForm.depositAcct = this.mulAcctRcptForm.depositAcct
        this.defaultForm.fund = this.mulAcctRcptForm.fund
        this.defaultForm.gstIO = this.mulAcctRcptForm.gstIO
        this.defaultForm.gstStatus = this.mulAcctRcptForm.gstStatus
        this.defaultForm.gstRate = this.mulAcctRcptForm.gstRate
        this.defaultForm.amountCurr = this.mulAcctRcptForm.amountCurr
        this.defaultForm.bankAmountCurr = this.mulAcctRcptForm.bankAmountCurr
        this.defaultForm.bankAmountCurrRate = this.mulAcctRcptForm.bankAmountCurrRate
        this.defaultForm.amountCurrRate = this.mulAcctRcptForm.amountCurrRate
        this.defaultForm.bankChargesCurr = this.mulAcctRcptForm.bankChargesCurr
        this.defaultForm.bankTotalAmountCurr = this.mulAcctRcptForm.bankTotalAmountCurr
        this.defaultForm.bankTotalLocalCurr = this.mulAcctRcptForm.bankTotalLocalCurr
        this.defaultForm.printDocument = this.mulAcctRcptForm.printDocument
      }
      const tempData = {
        branch: this.mulAcctRcptForm.branch,
        accountNo: this.mulAcctRcptForm.accountNo,
        documentNo: this.mulAcctRcptForm.documentNo,
        docAE: this.mulAcctRcptForm.docAE,
        documentNoDisabled: this.mulAcctRcptForm.documentNoDisabled,
        transactionType: this.mulAcctRcptForm.transactionType,
        fund: this.mulAcctRcptForm.fund,
        accountNoSuffix: this.mulAcctRcptForm.accountNoSuffix,
        accountNoSuffixDesc: this.mulAcctRcptForm.accountNoSuffixDesc,
        transactionDate: this.mulAcctRcptForm.transactionDateDisp,
        transactionDateDisp: this.mulAcctRcptForm.transactionDateDisp,
        receivedFrom: this.mulAcctRcptForm.receivedFrom,
        depositAcct: this.mulAcctRcptForm.depositAcct,
        bankNo: this.mulAcctRcptForm.depositAcct,
        paymentMethod: this.mulAcctRcptForm.paymentMethod,
        cashBook: this.mulAcctRcptForm.cashBook,
        gstIO: this.mulAcctRcptForm.gstIO,
        gstStatus: this.mulAcctRcptForm.gstStatus,
        gstRate: this.mulAcctRcptForm.gstRate,
        currency: this.mulAcctRcptForm.currency,
        amount: this.mulAcctRcptForm.amount,
        gstAmount: this.mulAcctRcptForm.gstAmount,
        gstAmountAE: this.mulAcctRcptForm.gstAmountAE === true ? 'A' : 'E',
        netAmount: this.mulAcctRcptForm.netAmount,
        bankAmount: this.mulAcctRcptForm.bankAmount,
        bankAmountAE: this.mulAcctRcptForm.bankAmountAE === true ? 'A' : 'E',
        bankCharges: this.mulAcctRcptForm.bankCharges,
        bankTotalAmount: this.mulAcctRcptForm.bankTotalAmount,
        bankTotalLocal: this.mulAcctRcptForm.bankTotalLocal,
        bankTotalLocalAE: this.mulAcctRcptForm.bankTotalLocalAE === true ? 'A' : 'E',
        amountCurr: this.mulAcctRcptForm.amountCurr,
        gstAmountCurr: this.mulAcctRcptForm.gstAmountCurr,
        netAmountCurr: this.mulAcctRcptForm.netAmountCurr,
        bankAmountCurr: this.mulAcctRcptForm.bankAmountCurr,
        bankChargesCurr: this.mulAcctRcptForm.bankChargesCurr,
        bankTotalAmountCurr: this.mulAcctRcptForm.bankTotalAmountCurr,
        bankTotalLocalCurr: this.mulAcctRcptForm.bankTotalLocalCurr,
        printDocument: this.mulAcctRcptForm.printDocument,
        addressTo: this.mulAcctRcptForm.addressTo,
        policyNo: this.mulAcctRcptForm.policyNo,
        insdRefNo: this.mulAcctRcptForm.insdRefNo,
        companyName: this.mulAcctRcptForm.companyName,
        docAddress1: this.mulAcctRcptForm.docAddress1,
        docAddress2: this.mulAcctRcptForm.docAddress2,
        docAddress3: this.mulAcctRcptForm.docAddress3,
        docAddress4: this.mulAcctRcptForm.docAddress4,
        postalCode: this.mulAcctRcptForm.postalCode,
        details: this.mulAcctRcptForm.details,
        statementRef: this.mulAcctRcptForm.statementRef,
        department: this.mulAcctRcptForm.department,
        insuredName: this.mulAcctRcptForm.insuredName,
        claimNo: this.mulAcctRcptForm.claimNo,
        gstRegNo: this.mulAcctRcptForm.gstRegNo,
        taxInvoiceNo: this.mulAcctRcptForm.taxInvoiceNo,
        payerBank: this.mulAcctRcptForm.payerBank,
        payersChequeNo: this.mulAcctRcptForm.payersChequeNo,
        drawerName: this.mulAcctRcptForm.drawerName,
        creditCardNo: this.mulAcctRcptForm.creditCardNo,
        amountCurrRate: this.mulAcctRcptForm.amountCurrRate,
        bankAmountCurrRate: this.mulAcctRcptForm.bankAmountCurrRate,
        actionName: this.mulAcctRcptForm.actionName,
        bankTotalLocalCurrRate: this.mulAcctRcptForm.bankTotalLocalCurrRate,
        saveStatus: 'true'
      }
      this.accountList.push(tempData)
      this.btnSaveList = false

      this.doReset()
    },
    doReset() {
      var thisForm = this.mulAcctRcptForm
      Object.keys(this.mulAcctRcptForm).forEach(function(key, index) {
        thisForm[key] = ''
      })

      thisForm = this.reviewForm
      Object.keys(this.reviewForm).forEach(function(key, index) {
        thisForm[key] = ''
      })
      this.btnSaveList = false
      this.initDisabled = false
      this.defaultForm.isDisabled = true
      this.processingFlag = false
      this.resetMessages()
      this.resetValidator()
      this.doAccumulate()
      this.doLaunch()
    },
    async doReview(data) {
      this.resetMessages()
      this.resetValidator()
      this.reviewForm.accountNo = data.accountNo
      this.reviewForm.accountNoSuffix = data.accountNoSuffix
      this.reviewForm.branch = data.branch
      this.reviewForm.documentNo = data.documentNo
      this.reviewForm.transactionType = data.transactionType
      this.reviewForm.fund = data.fund

      this.mulAcctRcptForm.branch = data.branch
      this.mulAcctRcptForm.accountNo = data.accountNo
      this.mulAcctRcptForm.documentNo = data.documentNo
      this.mulAcctRcptForm.docAE = data.docAE === 'true' || data.docAE === true
      this.mulAcctRcptForm.documentNoDisabled = data.documentNoDisabled
      this.mulAcctRcptForm.transactionType = data.transactionType
      this.mulAcctRcptForm.fund = data.fund
      this.mulAcctRcptForm.accountNoSuffix = data.accountNoSuffix
      this.mulAcctRcptForm.accountNoSuffixDesc = data.accountNoSuffixDesc
      this.mulAcctRcptForm.transactionDate = data.transactionDate
      this.mulAcctRcptForm.transactionDateDisp = data.transactionDateDisp
      this.mulAcctRcptForm.receivedFrom = data.receivedFrom
      this.mulAcctRcptForm.depositAcct = data.depositAcct
      this.mulAcctRcptForm.bankNo = data.bankNo
      this.mulAcctRcptForm.paymentMethod = data.paymentMethod
      this.mulAcctRcptForm.cashBook = data.cashBook
      this.mulAcctRcptForm.gstIO = data.gstIO
      this.mulAcctRcptForm.gstStatus = data.gstStatus
      this.mulAcctRcptForm.gstRate = data.gstRate
      this.mulAcctRcptForm.currency = data.currency
      this.mulAcctRcptForm.amount = data.amount
      this.mulAcctRcptForm.gstAmount = data.gstAmount
      this.mulAcctRcptForm.gstAmountAE = data.gstAmountAE === 'A'
      this.mulAcctRcptForm.netAmount = data.netAmount
      this.mulAcctRcptForm.bankAmount = data.bankAmount
      this.mulAcctRcptForm.bankAmountAE = data.bankAmountAE === 'A'
      this.mulAcctRcptForm.bankCharges = data.bankCharges
      this.mulAcctRcptForm.bankTotalAmount = data.bankTotalAmount
      this.mulAcctRcptForm.bankTotalLocal = data.bankTotalLocal
      this.mulAcctRcptForm.bankTotalLocalAE = data.bankTotalLocalAE === 'A'
      this.mulAcctRcptForm.amountCurr = data.amountCurr
      this.mulAcctRcptForm.gstAmountCurr = data.gstAmountCurr
      this.mulAcctRcptForm.netAmountCurr = data.netAmountCurr
      this.mulAcctRcptForm.bankAmountCurr = data.bankAmountCurr
      this.mulAcctRcptForm.bankChargesCurr = data.bankChargesCurr
      this.mulAcctRcptForm.bankTotalAmountCurr = data.bankTotalAmountCurr
      this.mulAcctRcptForm.bankTotalLocalCurr = data.bankTotalLocalCurr
      this.mulAcctRcptForm.printDocument = data.printDocument
      this.mulAcctRcptForm.addressTo = data.addressTo
      this.mulAcctRcptForm.policyNo = data.policyNo
      this.mulAcctRcptForm.insdRefNo = data.insdRefNo
      this.mulAcctRcptForm.companyName = data.companyName
      this.mulAcctRcptForm.docAddress1 = data.docAddress1
      this.mulAcctRcptForm.docAddress2 = data.docAddress2
      this.mulAcctRcptForm.docAddress3 = data.docAddress3
      this.mulAcctRcptForm.docAddress4 = data.docAddress4
      this.mulAcctRcptForm.postalCode = data.postalCode
      this.mulAcctRcptForm.details = data.details
      this.mulAcctRcptForm.statementRef = data.statementRef
      this.mulAcctRcptForm.department = data.department
      this.mulAcctRcptForm.insuredName = data.insuredName
      this.mulAcctRcptForm.claimNo = data.claimNo
      this.mulAcctRcptForm.gstRegNo = data.gstRegNo
      this.mulAcctRcptForm.taxInvoiceNo = data.taxInvoiceNo
      this.mulAcctRcptForm.payerBank = data.payerBank
      this.mulAcctRcptForm.payersChequeNo = data.payersChequeNo
      this.mulAcctRcptForm.drawerName = data.drawerName
      this.mulAcctRcptForm.creditCardNo = data.creditCardNo
      this.mulAcctRcptForm.amountCurrRate = data.amountCurrRate
      this.mulAcctRcptForm.bankAmountCurrRate = data.bankAmountCurrRate
      this.mulAcctRcptForm.actionName = data.actionName
      this.mulAcctRcptForm.bankTotalLocalCurrRate = data.bankTotalLocalCurrRate
      this.mulAcctRcptForm.createdBy = await this.fetchUserDetails(data.createdBy)
      this.mulAcctRcptForm.createdDate = data.createdDate
      this.mulAcctRcptForm.modifiedBy = await this.fetchUserDetails(data.modifiedBy)
      this.mulAcctRcptForm.modifiedDate = data.modifiedDate

      this.btnSaveList = true
      if (this.accountList.length <= 1) {
        this.defaultForm.isDisabled = false
        this.headerPanel = [0]
      }
    },
    doRemove(data) {
      if (this.receiptData.tranMode === '' || (this.receiptData.tranMode === 'R' && data.index !== 0)) {
        this.doRemoveRecord(data.item)
        this.doReset()
      } else if (this.receiptData.tranMode === 'R' && data.index === 0) {
        this.promptWarning = true
        this.warningMsg = 'First record not allow to delete'
      }
      if (this.accountList.length === 0) {
        this.tDateRange.effDate = null
      }
    },
    doRemoveRecord(data) {
      for (var i = 0; i < this.accountList.length; i++) {
        if (
          this.accountList[i].branch === data.branch &&
          this.accountList[i].transactionType === data.transactionType &&
          this.accountList[i].documentNo === data.documentNo &&
          this.accountList[i].accountNo === data.accountNo &&
          this.accountList[i].fund === data.fund &&
          this.accountList[i].accountNoSuffix === data.accountNoSuffix
        ) {
          this.$delete(this.accountList, i)
        }
      }

      this.doAccumulate()
      var thisForm = this.reviewForm
      Object.keys(this.reviewForm).forEach(function(key, index) {
        thisForm[key] = null
      })
    },
    doResaveRecord() {
      for (var a = 0; a < this.accountList.length; a++) {
        let bankAmt = 0.0
        let bankTotAmt = 0.0
        // let bankCharges = 0.00
        if (
          this.accountList[a].depositAcct === this.mulAcctRcptForm.depositAcct &&
          this.accountList[a].accountNoSuffix === this.mulAcctRcptForm.accountNoSuffix
        ) {
        } else {
          if (this.accountList[a].gstAmountAE === 'A') {
            this.accountList[a].gstAmount = formatPrice((removeFormatNumber(this.accountList[a].amount) * this.mulAcctRcptForm.gstRate) / 100)
          }
          if (this.accountList[a].gstIO === 'B') {
            this.accountList[a].netAmount = formatPrice(Number(removeFormatNumber(this.accountList[a].amount)))
          }
          if (this.accountList[a].gstIO === 'I') {
            this.accountList[a].netAmount = formatPrice(
              removeFormatNumber(this.accountList[a].amount) - Number(removeFormatNumber(this.accountList[a].gstAmount))
            )
          }
          if (this.accountList[a].gstIO === 'O') {
            this.accountList[a].netAmount = formatPrice(
              Number(removeFormatNumber(this.accountList[a].amount)) + Number(removeFormatNumber(this.accountList[a].gstAmount))
            )
          }
          if (this.accountList[a].bankAmountAE === 'A') {
            this.accountList[a].bankAmount = formatPrice(
              (removeFormatNumber(this.accountList[a].netAmount) * this.mulAcctRcptForm.amountCurrRate) / this.mulAcctRcptForm.bankAmountCurrRate
            )
          }
          // Bank Amount - Bank Charges
          this.accountList[a].bankTotalAmount = formatPrice(
            removeFormatNumber(this.accountList[a].bankAmount) - removeFormatNumber(this.accountList[a].bankCharges)
          )
          if (this.accountList[a].bankTotalLocalAE === 'A') {
            if (this.accountList[a].bankAmountAE) {
              bankAmt =
                (Number(removeFormatNumber(this.accountList[a].netAmount)) * Number(removeFormatNumber(this.mulAcctRcptForm.amountCurrRate))) /
                Number(removeFormatNumber(this.mulAcctRcptForm.bankAmountCurrRate))
            } else {
              bankAmt = removeFormatNumber(this.accountList[a].bankAmount)
            }
            bankTotAmt = Number(bankAmt) - Number(removeFormatNumber(this.accountList[a].bankCharges))
            bankTotAmt = bankTotAmt * Number(this.mulAcctRcptForm.bankAmountCurrRate)
            this.accountList[a].bankTotalLocal = formatPrice(bankTotAmt)
          }
          this.accountList[a].transactionDate = this.mulAcctRcptForm.transactionDateDisp
          this.accountList[a].transactionDateDisp = this.mulAcctRcptForm.transactionDateDisp
          this.accountList[a].gstStatus = this.mulAcctRcptForm.gstStatus
          this.accountList[a].gstRate = this.mulAcctRcptForm.gstRate
          this.accountList[a].amountCurrRate = this.mulAcctRcptForm.amountCurrRate
          this.accountList[a].bankAmountCurrRate = this.mulAcctRcptForm.bankAmountCurrRate
          this.accountList[a].saveStatus = 'true'
        }
      }
      this.defaultForm.transactionDateDisp = this.mulAcctRcptForm.transactionDateDisp
      this.defaultForm.gstStatus = this.mulAcctRcptForm.gstStatus
      this.defaultForm.gstRate = this.mulAcctRcptForm.gstRate
      this.defaultForm.amountCurrRate = this.mulAcctRcptForm.amountCurrRate
      this.defaultForm.bankAmountCurrRate = this.mulAcctRcptForm.bankAmountCurrRate
    },
    doSaveAccount() {
      let addRecord = true
      this.existAcctPay = false
      if (this.initDisabled) {
        this.doResaveRecord()
      }
      for (var i = 0; i < this.accountList.length; i++) {
        if (this.accountList[i].accountNo === this.reviewForm.accountNo && this.accountList[i].accountNoSuffix === this.reviewForm.accountNoSuffix) {
          this.checkChequeNo()
          addRecord = false
        } else {
          if (
            this.accountList[i].accountNo === this.mulAcctRcptForm.accountNo &&
            this.accountList[i].accountNoSuffix === this.mulAcctRcptForm.accountNoSuffix
          ) {
            this.duplicateForm.acctNo = this.mulAcctRcptForm.accountNo
            this.duplicateForm.suffix = this.mulAcctRcptForm.accountNoSuffix
            this.promptDuplicateAccount = true
            this.existAcctPay = true
            addRecord = false
          }
        }
      }
      if (addRecord) {
        this.checkChequeNo()
      }
    },
    doCancelAccount() {
      if (this.accountList.length <= 1) {
        this.defaultForm.isDisabled = true
        this.defaultForm.branch = this.mulAcctRcptForm.branch
        this.defaultForm.documentNo = this.mulAcctRcptForm.documentNo
        this.defaultForm.transactionType = this.mulAcctRcptForm.transactionType
        this.defaultForm.docAE = this.mulAcctRcptForm.docAE
        this.defaultForm.transactionDateDisp = this.mulAcctRcptForm.transactionDateDisp
        this.defaultForm.paymentMethod = this.mulAcctRcptForm.paymentMethod
        this.defaultForm.payersChequeNo = this.mulAcctRcptForm.payersChequeNo
        this.defaultForm.depositAcct = this.mulAcctRcptForm.depositAcct
        this.defaultForm.fund = this.mulAcctRcptForm.fund
        this.defaultForm.gstIO = this.mulAcctRcptForm.gstIO
        this.defaultForm.gstStatus = this.mulAcctRcptForm.gstStatus
        this.defaultForm.gstRate = this.mulAcctRcptForm.gstRate
        this.defaultForm.amountCurr = this.mulAcctRcptForm.amountCurr
        this.defaultForm.bankAmountCurr = this.mulAcctRcptForm.bankAmountCurr
        this.defaultForm.bankAmountCurrRate = this.mulAcctRcptForm.bankAmountCurrRate
        this.defaultForm.amountCurrRate = this.mulAcctRcptForm.amountCurrRate
        this.defaultForm.bankChargesCurr = this.mulAcctRcptForm.bankChargesCurr
        this.defaultForm.bankTotalAmountCurr = this.mulAcctRcptForm.bankTotalAmountCurr
        this.defaultForm.bankTotalLocalCurr = this.mulAcctRcptForm.bankTotalLocalCurr
        this.defaultForm.printDocument = this.mulAcctRcptForm.printDocument
      }
      this.doReset()
    },
    doAccumulate() {
      this.grandTotForm.receipt = '0.00'
      this.grandTotForm.gst = '0.00'
      this.grandTotForm.net = '0.00'
      this.grandTotForm.bankAmt = '0.00'
      this.grandTotForm.charges = '0.00'
      this.grandTotForm.total = '0.00'
      this.grandTotForm.localTotal = '0.00'

      for (var i = 0; i < this.accountList.length; i++) {
        this.grandTotForm.receipt = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.receipt)) + Number(removeFormatNumber(this.accountList[i].amount))
        )
        this.grandTotForm.gst = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.gst)) + Number(removeFormatNumber(this.accountList[i].gstAmount))
        )
        this.grandTotForm.net = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.net)) + Number(removeFormatNumber(this.accountList[i].netAmount))
        )
        this.grandTotForm.bankAmt = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.bankAmt)) + Number(removeFormatNumber(this.accountList[i].bankAmount))
        )
        this.grandTotForm.charges = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.charges)) + Number(removeFormatNumber(this.accountList[i].bankCharges))
        )
        this.grandTotForm.total = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.total)) + Number(removeFormatNumber(this.accountList[i].bankTotalAmount))
        )
        this.grandTotForm.localTotal = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.localTotal)) + Number(removeFormatNumber(this.accountList[i].bankTotalLocal))
        )
      }
    },
    closeDupAcctDialog() {
      this.promptDuplicateAccount = false
    },
    doProceed() {
      this.promptConfirmation = false
      this.doValidateMulAcctForm()
    },
    doSaveReceipt(actionName) {
      this.mulAcctRcptForm.actionName = actionName
      this.processingFlag = true
      if (this.receiptData.tranMode === 'R') {
        if (actionName === 'CREATE_SAVE_REVIEW') {
          this.mulAcctRcptForm.actionName = 'UPDATE_SAVE_REVIEW'
        } else if (actionName === 'CREATE_SAVE_POST') {
          this.mulAcctRcptForm.actionName = 'UPDATE_SAVE_POST'
        } else if (actionName === 'CREATE_MATCH_LATER') {
          this.mulAcctRcptForm.actionName = 'UPDATE_MATCH_LATER'
        }
      }
      if (this.accountList.length > 0) {
        this.mulAcctRcptForm.accountList = this.accountList
        this.performSaveMultAcctRcpt()
      } else {
        this.promptWarning = true
        this.processingFlag = false
        this.warningMsg = 'No Receipt Record to be save.'
      }
    },
    doValidateMulAcctForm() {
      let isMandatoryFormValid = false
      let isOptionalFormValid = false
      this.resetMessages()
      this.$validator.validateAll('receiptsMandatoryForm').then(result => {
        if (result) {
          this.ValidateTranDateRange(this.mulAcctRcptForm.transactionDateDisp, '003').then(result => {
            if (result) {
              if (this.receiptData.tranMode !== 'R') {
                this.validateIntermediary(this.mulAcctRcptForm.transactionDateDisp, this.mulAcctRcptForm.receivedFrom).then(() => {
                  if (this.promptMsg === false || this.acceptInterWarn === true) {
                    this.validStatus.mandatory = true
                    isMandatoryFormValid = true
                  } else {
                    this.setValidationValues(0)
                    isMandatoryFormValid = false
                  }
                  if (isMandatoryFormValid === true) {
                    this.$validator.validateAll('receiptsOptionalForm').then(result => {
                      if (result) {
                        this.validStatus.optional = true
                        isOptionalFormValid = true
                      } else {
                        this.setValidationValues(1)
                        isOptionalFormValid = false
                      }
                      if (isOptionalFormValid === true) {
                        this.validatePaymentForm()
                      }
                    })
                  }
                })
              } else {
                this.validStatus.mandatory = true
                isMandatoryFormValid = true
                if (isMandatoryFormValid === true) {
                  this.$validator.validateAll('receiptsOptionalForm').then(result => {
                    if (result) {
                      this.validStatus.optional = true
                      isOptionalFormValid = true
                    } else {
                      this.setValidationValues(1)
                      isOptionalFormValid = false
                    }
                    if (isOptionalFormValid === true) {
                      this.validatePaymentForm()
                    }
                  })
                }
              }
            } else {
              this.setValidationValues(0)
              isMandatoryFormValid = false
            }
          })
        } else {
          this.setValidationValues(0)
          isMandatoryFormValid = false
        }
      })
    },
    validatePaymentForm() {
      // Check if Payment Fields are Mandatory
      if (
        this.paymentmethod.payChqNo === 'M' ||
        this.paymentmethod.drawName === 'M' ||
        this.paymentmethod.crcdNo === 'M' ||
        this.paymentmethod.payBank === 'M'
      ) {
        this.$validator.validateAll('receiptsPaymentForm').then(result => {
          if (result) {
            this.validStatus.paymentmethod = true
            if (this.existAcctPay === false) {
              this.doRemoveRecord(this.reviewForm)
              this.doProceedSaveMulAcct()
            }
          } else {
            this.setValidationValues(2)
          }
        })
      } else {
        if (this.existAcctPay === false) {
          this.doRemoveRecord(this.reviewForm)
          this.doProceedSaveMulAcct()
        }
      }
    },
    setValidationValues(tabId) {
      this.processingFlag = false
      if (tabId === 0) this.validStatus.mandatory = false
      if (tabId === 1) this.validStatus.optional = false
      if (tabId === 2) this.validStatus.paymentmethod = false
      this.tabsNav = tabId
    },
    doValidateMandatory(tabId) {
      this.resetMessages()
      if (tabId === 1) {
        this.$validator.validateAll('receiptsMandatoryForm').then(result => {
          if (result) {
            this.ValidateTranDateRange(this.mulAcctRcptForm.transactionDateDisp, '003').then(result => {
              if (result) {
                if (this.receiptData.tranMode !== 'R') {
                  this.validateIntermediary(this.mulAcctRcptForm.transactionDateDisp, this.mulAcctRcptForm.receivedFrom).then(() => {
                    if (this.promptMsg === false || this.acceptInterWarn === true) {
                      this.validStatus.mandatory = true
                      this.tabsNav = tabId
                    } else {
                      this.validStatus.mandatory = false
                      this.tabsNav = 0
                    }
                  })
                } else {
                  this.validStatus.mandatory = true
                  this.tabsNav = tabId
                }
              } else {
                this.validStatus.mandatory = false
                this.tabsNav = 0
              }
            })
          } else {
            this.validStatus.mandatory = false
            this.tabsNav = 0
            this.promptFieldCheck()
          }
        })
      } else if (tabId === 2) {
        this.$validator.validateAll('receiptsMandatoryForm').then(result => {
          if (result) {
            this.ValidateTranDateRange(this.mulAcctRcptForm.transactionDateDisp, '003').then(result => {
              if (result) {
                if (this.receiptData.tranMode !== 'R') {
                  this.validateIntermediary(this.mulAcctRcptForm.transactionDateDisp, this.mulAcctRcptForm.receivedFrom).then(() => {
                    if (this.promptMsg === false || this.acceptInterWarn === true) {
                      this.$validator.validateAll('receiptsOptionalForm').then(result => {
                        if (result) {
                          this.validStatus.optional = true
                          this.tabsNav = tabId
                        } else {
                          this.validStatus.optional = false
                          this.tabsNav = 1
                        }
                      })
                    } else {
                      this.validStatus.mandatory = false
                      this.tabsNav = 0
                    }
                  })
                } else {
                  this.$validator.validateAll('receiptsOptionalForm').then(result => {
                    if (result) {
                      this.validStatus.optional = true
                      this.tabsNav = tabId
                    } else {
                      this.validStatus.optional = false
                      this.tabsNav = 1
                    }
                  })
                }
              } else {
                this.validStatus.mandatory = false
                this.tabsNav = 0
              }
            })
          } else {
            this.validStatus.mandatory = false
            this.tabsNav = 0
            this.promptFieldCheck()
          }
        })
      } else if (tabId === 3) {
        // Placeholder
      }
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    }
  },
  created() {
    this.$validator.extend('documentNo', {
      getMessage(field, args) {
        return 'This Receipt No. is already exist.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var isdocNoExist = args[0]
        if (isdocNoExist === 'true') {
          return false
        } else {
          return true
        }
      }
    })
  },
  mounted() {
    this.doInit()
  },
  components: {
    AcctNoHelpList,
    CurrencyHelpList,
    BankHelpList,
    AcctSufHelpList,
    AcctPolicyHelpList,
    ClaimHelpList,
    PromptLeave,
    SanctionPartialMatchList
  },
  mixins: [
    routeMixin,
    MessageMixin,
    mulAcctReceiptViewMixin,
    mulAcctReceiptAjaxMixin,
    receiptsAjaxMixin,
    commonAjaxMixin,
    promptOnExitMixin,
    TableConst.default
  ]
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
